/**
 * Year tabs for the Operational section.
 *
 * Per the Figma, the tabs show 5 years descending — the most recent at
 * the left (active by default), older years to the right. The most
 * recent year is the renewal year (i.e. the policy period the
 * underwriter is reviewing); when there's no renewal date yet (Draft
 * submissions), the current calendar year is used as a fallback.
 *
 * TODO(or-1147-stage2): per the Figma question annotation, support a
 * way to ADD a new year so underwriters can extend the look-back. For
 * now the range is fixed.
 */

export const YEAR_LOOKBACK = 5;

/** Parse the renewal year out of an ISO date (`YYYY-MM-DD`). Returns
 *  `null` when the string isn't parseable. */
export function renewalYear(isoDate: string | undefined | null): number | null {
    if (!isoDate) return null;
    const match = /^(\d{4})-/.exec(isoDate);
    if (!match) return null;
    const year = Number(match[1]);
    return Number.isFinite(year) ? year : null;
}

/** Build the descending year list shown in the tab strip. */
export function operationalYears(renewalDate: string | undefined | null): number[] {
    const anchor = renewalYear(renewalDate) ?? new Date().getFullYear();
    return Array.from({ length: YEAR_LOOKBACK }, (_, i) => anchor - i);
}
